export enum OidcConfiguration {
  Auth0 = 'auth0',
  Cognito = 'cognito'
}

